import { FC, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../../../../auth';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import axios from 'axios';
import { successToast, errorToast } from '../../../../../../../_metronic/helpers/components/Toaster';
import WhatsappDocuments from './WhatsappDocuments';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const TransportPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const { currentUser } = useAuth()
    const userType = (currentUser as any).userType;
    const [selectedDocs, setSelectedDocs] = useState<any[]>([]);

    const handleDocToggle = (doc: any) => {
        const isSelected = selectedDocs.some(d => d.docUrl === doc.docUrl);
        if (isSelected) {
            setSelectedDocs(selectedDocs.filter(d => d.docUrl !== doc.docUrl));
        } else {
            setSelectedDocs([...selectedDocs, doc]);
        }
    };



    const location = useLocation();
    const currentPath = location.pathname;
    const shouldHide =
        currentPath.includes('apps/sales/supply-orders') ||
        currentPath.includes('apps/purchase/supply-orders') ||
        currentPath.includes('apps/finance/supply-orders2') ||
        currentPath.includes('apps/logic/supply-orders');




    const shouldHide2 =
        currentPath.includes('apps/sales/reconcillation') ||
        currentPath.includes('apps/finance/payment') ||
        currentPath.includes('apps/purchase/reconcillation') ||
        currentPath.includes('apps/purchase/PayablesPurchaseAdmin') ||
        currentPath.includes('apps/logic/payables') ||
        currentPath.includes('apps/finance/payablesFinance') ||
        currentPath.includes('apps/transactions/quality-assessment') ||
        currentPath.includes('apps/transactions/payment-recycler')

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>



                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '20px',
                        tableLayout: 'fixed'
                    }}>
                        <thead>
                            <tr>
                                <th style={{
                                    width: '50%',
                                    backgroundColor: "#BFD7ED",
                                    color: "black",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    textAlign: "center",
                                    border: "1px solid #ddd"
                                }}>
                                    Purchase Order
                                </th>
                                <th style={{
                                    width: '50%',
                                    backgroundColor: "#BFD7ED",
                                    color: "black",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    textAlign: "center",
                                    border: "1px solid #ddd"
                                }}>
                                    Sale Order
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>
                                    {user?.purchaseOrderId}
                                </td>
                                <td style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>
                                    {user?.saleOrderDetail?.saleOrderId}
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    {!shouldHide2 && (
                        <>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Delivery Address</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user.deliveryAddress || 'N/A'}</td>
                                    </tr>

                                </tbody>
                            </table>

                            {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead >
                                    <tr className="fw-bold text-muted bg-light">
                                        <th className="min-w-100px ps-4" style={{ backgroundColor: '#BFD7ED', color: "black" }}> Category</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Item</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Grade</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Color</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Packaging</th>
                                        <th className="min-w-100px" style={{ backgroundColor: '#BFD7ED', color: "black" }}>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="ps-4">
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.categoryName || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].itemName || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].grade || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].color || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].packagingType || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.orderDetail?.[0]?.items?.[0].quantity || 'N/A'} Kg
                                            </span>
                                        </td>

                                    </tr>
                                </tbody>
                            </table> */}

                            <div className="table-responsive">
                                <table style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    marginBottom: "20px",
                                    border: "1px solid #ddd"
                                }}>
                                    <thead>
                                        <tr>
                                            <th
                                                colSpan={2}
                                                style={{
                                                    backgroundColor: "#BFD7ED",
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    padding: "12px",
                                                    textAlign: "left",
                                                    border: "1px solid #ddd"
                                                }}>
                                                Order Details
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{
                                                width: "33%",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd",
                                                fontWeight: "bold"
                                            }}>
                                                Category
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.orderDetail?.[0]?.categoryName || 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Item
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.orderDetail?.[0]?.items?.[0]?.itemName || 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Grade
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.orderDetail?.[0]?.items?.[0]?.grade || 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Color
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.orderDetail?.[0]?.items?.[0]?.color || 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Packaging
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.orderDetail?.[0]?.items?.[0]?.packagingType || 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                fontWeight: "bold",
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Quantity
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                {user?.orderDetail?.[0]?.items?.[0]?.quantity || 'N/A'} Kg
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                        </>)}




                    {!shouldHide && (
                        <>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Delivery Address</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>PO Number</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user.deliveryAddress || 'N/A'}</td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user.poNumber || 'N/A'}</td>
                                    </tr>

                                </tbody>
                            </table>
                            {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ fontWeight: "bold", paddingLeft: "10px" }}>Category</th>
                                        <th style={{ fontWeight: "bold" }}>Item</th>
                                        <th style={{ fontWeight: "bold" }}>Grade</th>
                                        <th style={{ fontWeight: "bold" }}>Color</th>
                                        <th style={{ fontWeight: "bold" }}>Packaging</th>
                                        <th style={{ fontWeight: "bold" }}>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {user?.dispatchOrderDetail?.map((order: any, index: number) => (
                                        order.items.map((item: any, itemIndex: number) => (
                                            <tr key={`${index}-${itemIndex}`}>
                                                <td>{order.categoryName || 'N/A'}</td>
                                                <td>{item.itemName || 'N/A'}</td>
                                                <td>{item.grade || 'N/A'}</td>
                                                <td>{item.color || 'N/A'}</td>
                                                <td>{item.packagingType || 'N/A'}</td>
                                                <td>{item.quantity || 'N/A'} Kg</td>
                                            </tr>
                                        ))
                                    )) || (
                                            <tr>
                                                <td colSpan={6} className="text-center">No Items Found</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table> */}




                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Category</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Item</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.dispatchOrderDetail?.map((order: any, index: number) => (
                                        order.items.map((item: any, itemIndex: number) => (
                                            <tr key={`first-${index}-${itemIndex}`}>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{order.categoryName || 'N/A'}</td>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{item.itemName || 'N/A'}</td>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{item.quantity || 'N/A'} Kg</td>
                                            </tr>
                                        ))
                                    )) || (
                                            <tr>
                                                <td colSpan={3} className="text-center">No Items Found</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>

                            {/* Second Table with Color, Grade, Packaging */}
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Color</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Grade</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Packaging</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.dispatchOrderDetail?.map((order: any, index: number) => (
                                        order.items.map((item: any, itemIndex: number) => (
                                            <tr key={`second-${index}-${itemIndex}`}>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{item.color || 'N/A'}</td>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{item.grade || 'N/A'}</td>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{item.packagingType || 'N/A'}</td>
                                            </tr>
                                        ))
                                    )) || (
                                            <tr>
                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>No Items Found</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>

                            {/* <div className="text-center mb-13">
                                <h1 className="mb-3 text-start">Invoice Information</h1>
                            </div>
                            <div className="d-flex flex-wrap gap-3">
                                {user?.dispatchImages?.filter(img => img.docType === "PFC_INVOICE").length > 0 ? (
                                    user?.dispatchImages
                                        .filter(img => img.docType === "PFC_INVOICE")
                                        .map((img, index) => (
                                            <div key={index} className="text-center">
                                                <img
                                                    src={img.docUrl}
                                                    alt={`Invoice ${index + 1}`}
                                                    className="h-150px w-150px object-cover rounded cursor-pointer"
                                                    style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                    onClick={() => window.open(img.docUrl, '_blank')}
                                                    onError={(e) => {
                                                        e.currentTarget.src = '/media/avatars/blank.png';
                                                    }}
                                                />
                                            </div>
                                        ))
                                ) : (
                                    <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                )}
                            </div> */}

                        </>)}









                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead>
                                <tr className="fw-bold  bg-light">
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Vehicle Number</th>
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>LR Number</th>
                                    <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Delivery Challan</th>

                                    {userType !== 'RECYCLER' && (
                                        <th className="min-w-100px" style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Invoice No</th>
                                    )}

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.vehicleDetails?.vehicleNo || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.lrNo || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.dcNo || 'N/A'}
                                        </span>
                                    </td>
                                    {userType !== 'RECYCLER' && (
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.invoiceNo || 'N/A'}
                                            </span>
                                        </td>
                                    )}
                                </tr>
                            </tbody>
                        </table>
                    </div>










                    {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">

                        <thead style={{ backgroundColor: '#BFD7ED' }}>
                            <tr className="fw-bold" style={{
                                paddingLeft:"10px"
                            }}>
                                <th>Address</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr>
                                <td>{user.deliveryAddress || 'N/A'}</td>
                            </tr>

                        </tbody>

                    </table> */}



















                    <div className="table-responsive ">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead >
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px" style={{ backgroundColor: '#bfd7ed', color: 'black', paddingLeft: "10px" }}>Transport Images</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 flex-wrap">
                                            {user.transportImages?.length > 0 ? (
                                                user.transportImages.map((img, index) => (
                                                    <div key={index} className="text-center" style={{ position: 'relative' }}>
                                                        <div style={{ position: 'absolute', top: '5px', left: '5px', zIndex: 10 }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedDocs.some(d => d.docUrl === img.docUrl)}
                                                                onChange={() => handleDocToggle(img)}
                                                                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                        <img
                                                            src={img.docUrl}
                                                            alt={`Document ${index + 1}`}
                                                            className="h-150px w-150px object-cover rounded cursor-pointer"
                                                            style={{ maxWidth: '140px', border: '1px solid #eee' }}
                                                            onClick={() => window.open(img.docUrl, '_blank')}
                                                            onError={(e) => {
                                                                e.currentTarget.src = '/media/avatars/blank.png';
                                                            }}
                                                        />
                                                        <p className="mt-1 text-sm">{img.docType}</p>
                                                    </div>
                                                ))
                                            ) : (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>





                    {userType !== 'RECYCLER' && (
                        <div className="table-responsive">
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead>
                                    <tr className="fw-bold text-muted bg-light">
                                        <th className="min-w-100px" style={{ backgroundColor: '#bfd7ed', color: 'black', paddingLeft: "10px" }}>Documents</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="d-flex gap-4 flex-wrap">
                                                {/* {user.dispatchImages?.length > 0 ? (
                                                user.dispatchImages.map((img, index) => (
                                                    <div key={index} className="text-center">
                                                        <img
                                                            src={img.docUrl}
                                                            alt={`Document ${index + 1}`}
                                                            className="h-150px w-150px object-cover rounded cursor-pointer"
                                                            style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                            onClick={() => window.open(img.docUrl, '_blank')}
                                                            onError={(e) => {
                                                                e.currentTarget.src = '/media/avatars/blank.png';
                                                            }}
                                                        />
                                                    </div>
                                                ))
                                            ) : (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )} */}





                                                {/* {user.dispatchImages?.length > 0 ? (
                                                    user.dispatchImages
                                                        .filter(img => img.docType !== "PFC_INVOICE")
                                                        .map((img, index) => (
                                                            <div key={index} className="text-center">
                                                                <img
                                                                    src={img.docUrl}
                                                                    alt={`Document ${index + 1}`}
                                                                    className="h-150px w-150px object-cover rounded cursor-pointer"
                                                                    style={{ maxWidth: '140px', border: '1px solid #eee' }}
                                                                    onClick={() => window.open(img.docUrl, '_blank')}
                                                                    onError={(e) => {
                                                                        e.currentTarget.src = '/media/avatars/blank.png';
                                                                    }}
                                                                />
                                                                <p className="mt-1 text-sm">{img.docType}</p>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                                )} */}




                                                {/* {user.dispatchImages?.length > 0 ? (
                                                    user.dispatchImages
                                                        .filter(img => {
                                                            // If it's PFC_INVOICE, only show if docUrl is not null or empty
                                                            if (img.docType === 'PFC_INVOICE') {
                                                                return img.docUrl && img.docUrl.trim() !== '' && img.docUrl !== 'null';
                                                            }
                                                            // For other document types, show them
                                                            return true;
                                                        })
                                                        .map((img, index) => {
                                                            // Document types that should show PDF icon when they fail to load
                                                            const pdfDocTypes = ['INVOICE', 'DELIVERY_CHALLAN', 'LR_RECIEPT', 'E_BILL', 'WEIGHT_SLIP', 'PFC_INVOICE'];
                                                            const shouldShowPdfIcon = pdfDocTypes.includes(img.docType);

                                                            // Function to get display name for document type
                                                            const getDisplayName = (docType) => {
                                                                switch (docType) {
                                                                    case 'INVOICE':
                                                                        return 'Vendor Invoice';
                                                                    case 'PFC_INVOICE':
                                                                        return 'PFC Invoice';
                                                                    default:
                                                                        return docType;
                                                                }
                                                            };

                                                            return (
                                                                <div key={index} className="text-center">
                                                                    <div style={{ position: 'relative' }}>
                                                                        <img
                                                                            src={img.docUrl}
                                                                            alt={`Document ${index + 1}`}
                                                                            className="h-150px w-150px object-cover rounded cursor-pointer"
                                                                            style={{ maxWidth: '140px', border: '1px solid #eee' }}
                                                                            onClick={() => window.open(img.docUrl, '_blank')}
                                                                            onError={(e) => {
                                                                                if (shouldShowPdfIcon) {
                                                                                    // Show PDF icon for document types that are typically PDFs
                                                                                    const target = e.target as HTMLImageElement;
                                                                                    const parent = target.parentElement;

                                                                                    if (parent) {
                                                                                        target.style.display = 'none';

                                                                                        // Create PDF icon container
                                                                                        const pdfContainer = document.createElement('div');
                                                                                        pdfContainer.className = 'd-flex align-items-center justify-content-center cursor-pointer';
                                                                                        pdfContainer.style.cssText = `
                                            width: 140px; 
                                            height: 150px; 
                                            border: 1px solid #eee;
                                            background-color: #f8f9fa;
                                            border-radius: 4px;
                                        `;
                                                                                        pdfContainer.onclick = () => window.open(img.docUrl, '_blank');

                                                                                        // Create PDF icon (Bootstrap Icons)
                                                                                        const pdfIcon = document.createElement('i');
                                                                                        pdfIcon.className = 'bi bi-file-pdf text-danger';
                                                                                        pdfIcon.style.fontSize = '3rem';
                                                                                        pdfIcon.title = 'View PDF';

                                                                                        pdfContainer.appendChild(pdfIcon);
                                                                                        parent.appendChild(pdfContainer);
                                                                                    }
                                                                                } else {
                                                                                    // Show blank placeholder for other document types
                                                                                    (e.target as HTMLImageElement).src = '/media/avatars/blank.png';
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <p className="mt-1 text-sm">{getDisplayName(img.docType)}</p>
                                                                </div>
                                                            );
                                                        })
                                                ) : (
                                                    <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                                )} */}



                                                {user.dispatchImages?.length > 0 ? (
                                                    user.dispatchImages
                                                        .filter(img => {
                                                            // Check current path
                                                            const currentPath = window.location.pathname;
                                                            const isSupplyOrdersPath = currentPath === '/apps/sales/supply-orders';

                                                            // If it's PFC_INVOICE, only show if:
                                                            // 1. We're on the supply-orders path AND
                                                            // 2. docUrl is not null or empty
                                                            if (img.docType === 'PFC_INVOICE') {
                                                                return isSupplyOrdersPath && img.docUrl && img.docUrl.trim() !== '' && img.docUrl !== 'null';
                                                            }
                                                            // For other document types, show them normally
                                                            return true;
                                                        })
                                                        .map((img, index) => {
                                                            // Document types that should show PDF icon when they fail to load
                                                            const pdfDocTypes = ['INVOICE', 'DELIVERY_CHALLAN', 'LR_RECIEPT', 'E_BILL', 'WEIGHT_SLIP', 'PFC_INVOICE'];
                                                            const shouldShowPdfIcon = pdfDocTypes.includes(img.docType);

                                                            // Function to get display name for document type
                                                            const getDisplayName = (docType) => {
                                                                // Check current path
                                                                const currentPath = window.location.pathname;
                                                                const isSupplyOrdersPath = currentPath === '/apps/sales/supply-orders';

                                                                // Only use custom display names on supply-orders path
                                                                if (isSupplyOrdersPath) {
                                                                    switch (docType) {
                                                                        case 'INVOICE':
                                                                            return 'Vendor Invoice';
                                                                        case 'PFC_INVOICE':
                                                                            return 'PFC Invoice';
                                                                        default:
                                                                            return docType;
                                                                    }
                                                                }

                                                                // On other paths, just return the raw document type
                                                                return docType;
                                                            };

                                                            return (
                                                                <div key={index} className="text-center" style={{ position: 'relative' }}>
                                                                    <div style={{ position: 'absolute', top: '5px', left: '5px', zIndex: 10 }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedDocs.some(d => d.docUrl === img.docUrl)}
                                                                            onChange={() => handleDocToggle(img)}
                                                                            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                                        />
                                                                    </div>
                                                                    <div style={{ position: 'relative' }}>
                                                                        <img
                                                                            src={img.docUrl}
                                                                            alt={`Document ${index + 1}`}
                                                                            className="h-150px w-150px object-cover rounded cursor-pointer"
                                                                            style={{ maxWidth: '140px', border: '1px solid #eee' }}
                                                                            onClick={() => window.open(img.docUrl, '_blank')}
                                                                            onError={(e) => {
                                                                                if (shouldShowPdfIcon) {
                                                                                    // Show PDF icon for document types that are typically PDFs
                                                                                    const target = e.target as HTMLImageElement;
                                                                                    const parent = target.parentElement;

                                                                                    if (parent) {
                                                                                        target.style.display = 'none';

                                                                                        // Create PDF icon container
                                                                                        const pdfContainer = document.createElement('div');
                                                                                        pdfContainer.className = 'd-flex align-items-center justify-content-center cursor-pointer';
                                                                                        pdfContainer.style.cssText = `
                                            width: 140px; 
                                            height: 150px; 
                                            border: 1px solid #eee;
                                            background-color: #f8f9fa;
                                            border-radius: 4px;
                                        `;
                                                                                        pdfContainer.onclick = () => window.open(img.docUrl, '_blank');

                                                                                        // Create PDF icon (Bootstrap Icons)
                                                                                        const pdfIcon = document.createElement('i');
                                                                                        pdfIcon.className = 'bi bi-file-pdf text-danger';
                                                                                        pdfIcon.style.fontSize = '3rem';
                                                                                        pdfIcon.title = 'View PDF';

                                                                                        pdfContainer.appendChild(pdfIcon);
                                                                                        parent.appendChild(pdfContainer);
                                                                                    }
                                                                                } else {
                                                                                    // Show blank placeholder for other document types
                                                                                    (e.target as HTMLImageElement).src = '/media/avatars/blank.png';
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <p className="mt-1 text-sm">{getDisplayName(img.docType)}</p>
                                                                </div>
                                                            );
                                                        })
                                                ) : (
                                                    <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                                )}


                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}










                    {!shouldHide && (
                        <>
                            <div className="text-center mb-13">
                                <h1 className="mb-2 text-start">Invoice Information</h1>
                            </div>
                            <div className="d-flex flex-wrap gap-3">
                                {user?.dispatchImages?.filter(img => img.docType === "PFC_INVOICE").length > 0 ? (
                                    user?.dispatchImages
                                        .filter(img => img.docType === "PFC_INVOICE")
                                        .map((img, index) => (
                                            <div key={index} className="text-center" style={{ position: 'relative' }}>
                                                <div style={{ position: 'absolute', top: '5px', left: '5px', zIndex: 10 }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedDocs.some(d => d.docUrl === img.docUrl)}
                                                        onChange={() => handleDocToggle(img)}
                                                        style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                    />
                                                </div>
                                                <img
                                                    src={img.docUrl}
                                                    alt={`Invoice ${index + 1}`}
                                                    className="h-150px w-150px object-cover rounded cursor-pointer"
                                                    style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                    onClick={() => window.open(img.docUrl, '_blank')}
                                                    onError={(e) => {
                                                        e.currentTarget.src = '/media/avatars/blank.png';
                                                    }}
                                                />
                                            </div>
                                        ))
                                ) : (
                                    <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                )}
                            </div>
                        </>)}




















                    <hr />
                    <WhatsappDocuments
                        selectedDocs={selectedDocs}
                        setSelectedDocs={setSelectedDocs}
                        orderId={user?.orderId}
                    />

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>






            </div>
        </Modal>
    );
};